import React from 'react';
import PropTypes from 'prop-types';
import Menu from '../../../../../components/LazyWidgets/Menu';
import s from '../skillsFeedbackSummary.module.css';

const SkillFeedbackSummaryDropdown = (props) => {
  const { dropDownObject, activeDraft, handleFeedbackUpdate } = props;
  const index = dropDownObject.findIndex(elem => elem.id === activeDraft.id);
  const optSelected = index === -1
    ? dropDownObject[activeDraft.id]
    : dropDownObject[index];

  return (
    <div className={s.menuContainer}>
      <Menu
        className={s.menu}
        id="moduleId1"
        options={dropDownObject}
        onChange={handleFeedbackUpdate}
        selectedLabel={optSelected.name}
        hasLabel
        label="Feedback:"
        boxed
      />
    </div>
  );
};

SkillFeedbackSummaryDropdown.propTypes = {
  dropDownObject: PropTypes.array,
  activeDraft: PropTypes.object,
  handleFeedbackUpdate: PropTypes.func,
};

export default SkillFeedbackSummaryDropdown;
